import { useContext } from 'react';
import ThreadContext from '../context/ThreadContext';

const useThread = () => {
  return useContext(ThreadContext);
};

export default useThread;
